import e from"color";const t=t=>{if(t)try{return e(n(t)).rgb().hex()}catch{}return``};function n(e){return e.replace(`##`,`#`)}export{t as toRgbAsHex};
//# sourceMappingURL=to-rgb-as-hex.js.map